import React, { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { version } from '../../../package.json';

import { ToggleIcon } from './utils/ToggleIcon';
import logo from '../../assets/icons/logo.svg';
import logoClosed from '../../assets/icons/logo-closed.svg';
import { ROUTES } from '../../AppRouting';
import { RootState } from '../../store/store';
import { getCurrentPath } from '../utils';
import { ReactComponent as SubrouteIcon } from './subrouteIcon.svg';
import { SubRoutes } from '../../types';

export const Sidebar: React.FC = (): JSX.Element => {
  const { pathname } = useLocation();
  const { user } = useSelector((state: RootState) => state.auth);
  const [shouldCollapse, setShouldCollapse] = useState(
    window.innerWidth <= 1250
  );

  const handleCollapse = () => {
    setShouldCollapse(!shouldCollapse);
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      setShouldCollapse(window.innerWidth <= 1250);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <aside className={`sidebar ${shouldCollapse ? 'closed' : 'open'}`}>
      <div className="sidebar__top">
        <ToggleIcon onClick={handleCollapse} className="sidebar__toggle" />
        <img
          src={shouldCollapse ? logoClosed : logo}
          alt="Logo"
          className="sidebar__logo"
        />
      </div>
      <nav className="sidebar__nav">
        {ROUTES.map(({ path, label, Icon, roles, disabled, ...other }) =>
          roles.includes(user?.role as string) ? (
            <React.Fragment key={label}>
              <Link
                className={`sidebar__nav-link ${
                  pathname === getCurrentPath(path, user) ? 'active' : ''
                } ${disabled ? 'disabled' : ''}`}
                to={disabled ? pathname : getCurrentPath(path, user)}
              >
                <Icon
                  disabled={disabled}
                  className="sidebar__nav-link__icon"
                  active={pathname === getCurrentPath(path, user)}
                />
                <span>{label}</span>
              </Link>
              <>
                {'subroutes' in other ? (
                  <div className="sidebar__subroute-block">
                    {other.subroutes?.map((el: SubRoutes) => (
                      <Link
                        key={el.label}
                        className={`sidebar__subnav-link ${
                          pathname === getCurrentPath(el.path, user)
                            ? 'active'
                            : ''
                        } ${disabled ? 'disabled' : ''}`}
                        to={disabled ? pathname : getCurrentPath(el.path, user)}
                      >
                        {pathname === getCurrentPath(el.path, user) ? (
                          <SubrouteIcon className="sidebar__subnav-link__icon" />
                        ) : (
                          <span className="sidebar__subnav-link__icon" />
                        )}
                        <span>{el.label}</span>
                      </Link>
                    ))}
                  </div>
                ) : null}
              </>
            </React.Fragment>
          ) : null
        )}
      </nav>
      <div className="sidebar__version">Ver. {version}</div>
    </aside>
  );
};
